import { useState } from 'react';
import { MessageCircle, Mail, Phone, X } from 'lucide-react';

export const FloatingCTA = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      icon: MessageCircle,
      href: 'https://wa.me/918679032311?text=Hi%20Pond%20Skape!%20I%20am%20interested%20in%20your%20water%20design%20services.',
      color: 'bg-green-500 hover:bg-green-600',
      description: 'Chat with us'
    },
    {
      id: 'email',
      label: 'Email',
      icon: Mail,
      href: 'mailto:pondlife@gmail.com?subject=Inquiry%20about%20Pond%20Skape%20Services',
      color: 'bg-blue-500 hover:bg-blue-600',
      description: 'pondlife@gmail.com'
    },
    {
      id: 'phone-india',
      label: 'Call India',
      icon: Phone,
      href: 'tel:+918679032311',
      color: 'bg-orange-500 hover:bg-orange-600',
      description: '+91 86790 32311'
    },
    {
      id: 'phone-us',
      label: 'Call US',
      icon: Phone,
      href: 'tel:+14088937953',
      color: 'bg-purple-500 hover:bg-purple-600',
      description: '+1 408 893 7953'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end" data-testid="floating-cta">
      {/* Contact Options - Expanded */}
      {isOpen && (
        <div className="mb-4 flex flex-col gap-3">
          {contactOptions.map((option) => (
            <a
              key={option.id}
              href={option.href}
              target={option.id === 'whatsapp' ? '_blank' : '_self'}
              rel={option.id === 'whatsapp' ? 'noopener noreferrer' : undefined}
              className={`flex items-center gap-3 px-4 py-3 rounded-full text-white shadow-lg transform transition-all duration-300 hover:scale-105 hover:-translate-x-2 ${option.color}`}
              data-testid={`cta-${option.id}`}
            >
              <option.icon size={20} />
              <div className="pr-2">
                <span className="font-medium text-sm">{option.label}</span>
                <span className="block text-xs opacity-90">{option.description}</span>
              </div>
            </a>
          ))}
        </div>
      )}

      {/* Tooltip when closed */}
      {!isOpen && (
        <div className="mb-2 bg-stone-900 text-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-bounce-subtle">
          <span className="text-sm font-medium">Connect with us!</span>
        </div>
      )}

      {/* Main CTA Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-16 h-16 rounded-full shadow-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 ${
          isOpen 
            ? 'bg-stone-800 rotate-0' 
            : 'bg-green-500 hover:bg-green-600'
        }`}
        data-testid="cta-toggle-btn"
        aria-label="Contact options"
      >
        {isOpen ? (
          <X size={28} className="text-white" />
        ) : (
          <MessageCircle size={28} className="text-white" />
        )}
      </button>
    </div>
  );
};
